module.exports = __webpack_public_path__ + "static/media/upload-cloud.5b1947e4.svg";